import React from 'react';
import { Notification } from '@deal/components';
import { usePathContext } from '../../../../context/PathContext.js';
import LoginLinkHandler from '../../../../components/LoginLinkHandler/index.js';
import styles from './styles.css.js';

var NodeErrorHeader = function NodeErrorHeader() {
  var pathContext = usePathContext();

  if (pathContext.nodeLevelErrors && pathContext.nodeLevelErrors.length > 0) {
    return React.createElement(Notification, {
      type: "error",
      className: styles.notifications
    }, pathContext.nodeLevelErrors.map(function (error, idx) {
      switch (error.__typename) {
        case 'RequireLoginQuestionPathNodeFlowViewModelValidationError':
          return React.createElement("span", {
            key: idx
          }, error.errorMessage, " ", React.createElement(LoginLinkHandler, null));

        default:
          return React.createElement("span", {
            key: idx
          }, error.errorMessage);
      }
    }));
  }

  return null;
};

export default NodeErrorHeader;
//# sourceMappingURL=index.js.map
